import { useFormStore } from '@/stores/form'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import apiHelperService from '@/services'
import { reactive } from 'vue'

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const { administrativeRegionId = '' } = router.currentRoute.value.params

  formStore.extraMap = {
    ...formStore.extraMap,
    serviceTransactionId,
    administrativeRegionId
  }
}

const initInfo = async () => {
  const formStore = useFormStore()
  const { serviceTransactionId } = formStore.extraMap
  const res = await apiHelperService.get(`/api/individual/info`)
  if (res) {
    const {
      identityNumber,
      englishFullName,
      arabicFullName,
      familyBookNumber,
      martialStatusId,
      fileSequence,
      familyBookCityCode
    } = res
    formStore.form.setValues({
      identityNumber,
      familyBooKFamilySequence: familyBookNumber,
      applicantArbFullName: arabicFullName,
      applicantEngFullName: englishFullName,
      maritalStatusId: martialStatusId
    })
    formStore.draft.request = {
      motherIdentityNumber: identityNumber,
      arbMotherName: arabicFullName,
      engMotherName: englishFullName,
      fileSeqNo: fileSequence,
      familyBookCityCode,
      lookupLocalMaritalStatusId: martialStatusId,
      serviceTransId: router.currentRoute.value.params.serviceId
    }
  }
}

export default async function () {
  try {
    await initForm()
    await initInfo()
  } catch (error) {
    console.error('use838Preload error: ', error)
  }
}
